// Module
var code = "<div class=\"alert notice\" ng-if=$ctrl.showNotice> <span class=message translate translate-compile>global.ie11Support</span> <button type=button class=\"clean-button close\" ng-click=$ctrl.close()>&times;</button> </div> ";
// Exports
module.exports = code;